import { render, staticRenderFns } from "./closedSpaceEduDetail.vue?vue&type=template&id=1a84c708"
import script from "./closedSpaceEduDetail.vue?vue&type=script&lang=js"
export * from "./closedSpaceEduDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a84c708')) {
      api.createRecord('1a84c708', component.options)
    } else {
      api.reload('1a84c708', component.options)
    }
    module.hot.accept("./closedSpaceEduDetail.vue?vue&type=template&id=1a84c708", function () {
      api.rerender('1a84c708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/closedSpaceEduDetail.vue"
export default component.exports